import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import EmailValidateForm from '../components/EmailValidateForm';

const WWReset: React.FC = () => {
  return <EmailValidateForm />;
};

export default WWReset;
